export enum ApplyLimitOn {
    CalculatedPayerAmount = 1 , 
    ItemPrice = 2
}
